import React, { useEffect, useRef, useState } from "react";

/**
 * Lightweight custom cursor shaped like a pickleball (pure inline SVG — no image load).
 * Follows the pointer with a subtle lerp and grows over interactive elements.
 */
export default function Cursor() {
  const ref = useRef(null);
  const [hovering, setHovering] = useState(false);

  useEffect(() => {
    const el = ref.current;
    let x = window.innerWidth / 2, y = window.innerHeight / 2;
    let cx = x, cy = y, raf;
    const move = (e) => { x = e.clientX; y = e.clientY; };
    const loop = () => {
      cx += (x - cx) * 0.2; cy += (y - cy) * 0.2;
      if (el) el.style.transform = `translate(${cx}px, ${cy}px) translate(-50%, -50%) scale(${hovering ? 1.6 : 1})`;
      raf = requestAnimationFrame(loop);
    };
    const over = (e) => { if (e.target.closest("a, button, [data-hover], input, textarea, [role='tab']")) setHovering(true); };
    const out = (e) => { if (e.target.closest("a, button, [data-hover], input, textarea, [role='tab']")) setHovering(false); };
    window.addEventListener("mousemove", move);
    document.addEventListener("mouseover", over);
    document.addEventListener("mouseout", out);
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", over);
      document.removeEventListener("mouseout", out);
    };
  }, [hovering]);

  return (
    <div ref={ref} className="d2-cursor" aria-hidden="true">
      <svg width="30" height="30" viewBox="0 0 32 32">
        <g className="d2-ball-spin">
          <circle cx="16" cy="16" r="14" fill="#c3e935" stroke="#a9cf1e" strokeWidth="1" />
          <path d="M16 2a14 14 0 0 1 0 28A14 14 0 0 0 16 2z" fill="#000" opacity="0.06" />
          <ellipse cx="11" cy="9.5" rx="4.2" ry="2.8" fill="#fff" opacity="0.35" />
          {/* pickleball holes */}
          <circle cx="16" cy="6.5" r="2.1" fill="#fff" />
          <circle cx="16" cy="16" r="2.2" fill="#fff" />
          <circle cx="16" cy="25.5" r="2.1" fill="#fff" />
          <circle cx="8.5" cy="11.5" r="2" fill="#fff" />
          <circle cx="23.5" cy="11.5" r="2" fill="#fff" />
          <circle cx="8.5" cy="20.5" r="2" fill="#fff" />
          <circle cx="23.5" cy="20.5" r="2" fill="#fff" />
        </g>
      </svg>
    </div>
  );
}
